import { Injectable } from '@angular/core';
import {
  MyHttpClientFactory,
  ResponseCasingEnum,
  environment,
} from '@ups/xplat/core';
import { HttpClient } from '@angular/common/http';
import { EngagementCategoryDto } from '@ups/xplat/api/dto';

@Injectable({
  providedIn: 'root',
})
export class EngagementCategoryService {
  private http: HttpClient;

  constructor(private clientFactory: MyHttpClientFactory) {
    this.http = this.clientFactory.createHttpClient(
      environment.urls.spartaAPI,
      true,
      ResponseCasingEnum.CamelCase
    );
  }

  get() {
    return this.http.get<EngagementCategoryDto[]>(
      `/api/quote-log/engagement-categories`
    );
  }
}
